import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

import {
  Row, Col, DatePicker, Modal, Button, Card,
} from 'antd';
import Merchants from './index';

const { RangePicker } = DatePicker;

const WalletOverview = ({
  wallet,
  isAffiliate,
  overview,
  overviewLoading,
  handleChange,
}) => {
  const [visibleSelectChildMerchantModal, setVisibleSelectChildMerchantModal] = useState(false);
  const [selectedChildMerchant, setSelectedChildMerchant] = useState(null);

  const selectChildMerchant = () => {
    setVisibleSelectChildMerchantModal(true);
  };

  const closeSelectChildMerchantModal = () => {
    setVisibleSelectChildMerchantModal(false);
  };

  const OkSelectChildMerchantModal = (childMerchant) => {
    if (childMerchant) {
      setSelectedChildMerchant(childMerchant);
      handleChange(childMerchant._id, 'child_merchant');
    }
    setVisibleSelectChildMerchantModal(false);
  };

  const colSize = isAffiliate ? 8 : 12;

  const selectedTransactionType = 'CREDIT';

  let ledgerAmountDescription = 'COMMISSIONS';
  if (!isAffiliate) {
    ledgerAmountDescription = (selectedTransactionType === 'COLLECTION') ? 'CREDIT' : 'DEBIT';
  }

  return (
    <>
      <Row>
        <Col xl={colSize} lg={colSize} md={colSize} sm={colSize} xs={24}>
          <RangePicker onChange={(_, dateString) => handleChange(dateString, 'date_range')} style={{ width: '100%' }} />
        </Col>
        <Col xl={colSize} lg={colSize} md={colSize} sm={colSize} xs={24} />

        {isAffiliate
        && (
          <>
            <Col xl={8} lg={8} md={8} sm={8} xs={24}>
              <Button style={{ width: '100%' }} onClick={selectChildMerchant}>
                {selectedChildMerchant?.name || 'Child Merchant'}
              </Button>
            </Col>
            <Modal
              title="Select Child Merchant"
              open={visibleSelectChildMerchantModal}
              okText="Ok"
              onCancel={closeSelectChildMerchantModal}
              onOk={OkSelectChildMerchantModal}
            >
              <Merchants onSelect={OkSelectChildMerchantModal} />
            </Modal>
          </>
        )}
      </Row>
      <Row>
        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
          {overviewLoading
          && <span>loading... </span>}
        </Col>
      </Row>
      {!overviewLoading && overview && overview.total_transactions !== undefined
      && selectedTransactionType
      && (
        <div>
          <br />
          <Row>
            <Col xl={6} lg={6} md={12} sm={12} xs={24}>
              <Card style={{ background: '#f5f5f7' }}>
                <h3>{new Intl.NumberFormat().format(overview.total_transactions)}</h3>
                <br />
                <h6>TRANSACTIONS</h6>
              </Card>
            </Col>
            <Col xl={6} lg={6} md={12} sm={12} xs={24}>
              <Card style={{ background: '#fdfccf' }}>
                <h3>
                  {new Intl.NumberFormat().format(overview.total_transaction_amount)}
                  {' '}
                  {wallet?.currency?.code}
                </h3>
                <br />
                <h6>{selectedTransactionType || ''}</h6>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

WalletOverview.propTypes = {
  wallet: PropTypes.oneOfType([
    PropTypes.any,
  ]),
  overview: PropTypes.oneOfType([
    PropTypes.any,
  ]),
  overviewLoading: PropTypes.bool,
  isAffiliate: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};

WalletOverview.defaultProps = {
  wallet: null,
  overview: null,
  overviewLoading: false,
  isAffiliate: false,
};

export default WalletOverview;
